export default "__VITE_ASSET__c90a7296__"